
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import analytics from '@/utils/analytics';

interface AdminLoginProps {
  onLogin: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [adminPassword, setAdminPassword] = useState('');
  
  // Mock admin credentials - In a real app, this would be server-side validation
  const ADMIN_PASSWORD = 'admin123'; // This would not be hardcoded in a real app
  
  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (adminPassword === ADMIN_PASSWORD) {
      localStorage.setItem('hormony_admin_auth', 'true');
      toast.success('Admin authenticated successfully');
      analytics.trackUserAction('admin_login', { success: true });
      onLogin();
    } else {
      toast.error('Incorrect password');
      analytics.trackUserAction('admin_login', { success: false });
    }
  };

  return (
    <div className="container py-12 max-w-md">
      <Card>
        <CardHeader>
          <CardTitle>Admin Login</CardTitle>
          <CardDescription>
            Please enter your admin password to continue
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handlePasswordSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="password" className="text-sm font-medium">
                Password
              </label>
              <Input
                id="password"
                type="password"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                placeholder="Enter admin password"
                required
              />
            </div>
            <Button type="submit" className="w-full">
              Login
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
